module.exports = __webpack_public_path__ + "static/media/malte-wingen-381988-unsplash.ad041e75.jpg";